let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("2Ff1R")).then(() => parcelRequire('83K4u'));